import { createFileRoute } from "@tanstack/react-router";
import PortalPage from "src/components/app/PortalPage/PortalPage";
import MetadataFieldSettings from "src/components/app/ProjectSettings/MetadataFieldSettings";
import ContentPanel from "src/components/common/ContentPanel/ContentPanel";
import Typography from "src/components/common/Typography/Typography";
import DocLink from "src/components/docs/DocLink/DocLink";
import { usePortal } from "src/lib/contexts/PortalContext";
import { canProject } from "src/lib/ProjectPermissions";
import { useExtracted } from "#i18n";

export const Route = createFileRoute("/_authed/portal/proj_{$projectKey}/metadata")({
  component: MetadataPage,
});

function MetadataPage() {
  const t = useExtracted();
  const { projectTeam, selectedProject, projectTeamError } = usePortal();
  const canManage = canProject(projectTeam, "metadata:read");
  return (
    <PortalPage className="max-w-6xl">
      <PortalPage.Header>
        <PortalPage.Heading>
          <PortalPage.Title>{t("Metadata")}</PortalPage.Title>
          <PortalPage.Description>
            {t("Define the fields used to filter and group this project's assets.")}
          </PortalPage.Description>
          <PortalPage.Docs>
            <DocLink topic="metadata" />
          </PortalPage.Docs>
        </PortalPage.Heading>
      </PortalPage.Header>
      <PortalPage.Content>
        {!selectedProject ? (
          <ContentPanel.Content>
            <Typography tone="muted">{t("Select a project to manage metadata fields.")}</Typography>
          </ContentPanel.Content>
        ) : canManage ? (
          <MetadataFieldSettings key={selectedProject.id} />
        ) : (
          <ContentPanel.Content>
            <Typography tone="muted" role={projectTeamError ? "alert" : "status"}>
              {projectTeamError
                ? t(
                    "Unable to load project access. You may have been removed. Refresh or choose another project.",
                  )
                : projectTeam
                  ? t("You don't have access to this project's metadata fields.")
                  : t("Loading project access...")}
            </Typography>
          </ContentPanel.Content>
        )}
      </PortalPage.Content>
    </PortalPage>
  );
}
